import { render, staticRenderFns } from "./Botones.vue?vue&type=template&id=679f126d"
import script from "./Botones.vue?vue&type=script&lang=ts"
export * from "./Botones.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports